module.exports = __webpack_public_path__ + "static/dear-mr-henshaw-0be5a96882d065bef405103ec0b78c76.jpg";